import { VhcRecordLogService, VHCRecordPartInput } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateWheelPartsInput = {
  logId: number;
  itemId: number;
  partId: number;
  requestBody?: VHCRecordPartInput;
};

export const useUpdateWheelPartsMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsWheelTyresParts, UpdateWheelPartsInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, partId, requestBody }: UpdateWheelPartsInput) =>
      VhcRecordLogService.putVhcRecordsItemsWheelTyresParts(logId, itemId, partId, requestBody),
    options
  );
